import styled from 'styled-components';

export const Center = styled.div`
  display: grid;
  place-content: center;
  height: 100%;
  width: 100%;
  justify-items: center;
  align-content: center;
`;
